import React, { useState, useCallback, useEffect } from 'react';
import JumboContentLayout from '@jumbo/components/JumboContentLayout';
import useJumboTheme from '@jumbo/hooks/useJumboTheme';
import {
  Box,
  Button,
  Paper,
  Stack,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { ApiService } from 'app/servicesTwo/ApiService';
import { useParams, useLocation } from 'react-router-dom';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { GreatVibesRegular } from '../../../../assets/fonts/GreatVibes-regular';
import { CourseWithCertifiedList } from 'app/components/CourseWithCertifiedList/CourseWithCertifiedList';
import moment from 'moment';
import 'moment/locale/pt-br';
import { capitalizeFLetter } from '@jumbo/utils';
import useSwalWrapper from '@jumbo/vendors/sweetalert2/hooks';

const ModalCertified = ({ user, username, userId = null, handleClose }) => {
  const { theme } = useJumboTheme();

  pdfMake.vfs = pdfFonts.pdfMake.vfs;
  window.pdfMake.vfs['GreatVibes-Regular.ttf'] = GreatVibesRegular;
  pdfMake.fonts = {
    Roboto: {
      normal:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf',
      bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
      italics:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
      bolditalics:
        'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf',
    },
    GreatVibes: {
      normal: 'GreatVibes-Regular.ttf',
      bold: 'GreatVibes-Regular.ttf',
      italics: 'GreatVibes-Regular.ttf',
      bolditalics: 'GreatVibes-Regular.ttf',
    },
  };

  const Swal = useSwalWrapper();
  const toast = (variant, message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: 'top-end',
      showConfirmButton: false,
      onOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer);
        toast.addEventListener('mouseleave', Swal.resumeTimer);
      },
    });

    Toast.fire({
      icon: variant,
      title: message,
      showCloseButton: true, // botão de fechar
      closeButtonAriaLabel: 'Fechar',
    });
  };

  const lg = useMediaQuery(theme.breakpoints.down('lg'));
  const layoutOptions = React.useMemo(
    () => ({
      sidebar: {
        sx: {
          [theme.breakpoints.up('lg')]: {
            position: 'sticky',
            zIndex: 5,
            top: 96,
            minHeight: 'auto',
          },
          [theme.breakpoints.down('lg')]: { display: 'none' },
        },
      },
      wrapper: { sx: { alignItems: 'flex-start' } },
    }),
    [theme]
  );

  const { id } = useParams();
  const location = useLocation();

  const [courseHistoryFeespOnlyApproval, setCourseHistoryFeespOnlyApproval] =
    useState([]);
  const [modalTitle, setModalTitle] = useState('Histórico de Cursos');
  const [directors, setDirectors] = useState([]);

  const currentPath = location.pathname;
  const inClassesURL =
    currentPath.startsWith('/app/editar-turma') ||
    currentPath.startsWith('/app/listar-cursos-outras-entidades') ||
    currentPath.startsWith('/app/listar-curso-lote') ||
    currentPath.startsWith('/app/listar-consultar-historico') ||
    currentPath.startsWith('/app/listar-certificados');

  const idSelected = inClassesURL ? userId : id;

  const getCourseHistoryOnlyFeespApproved = useCallback(async () => {
    try {
      ApiService.get(`/historico-cursos-feesp/${idSelected}?approved=${true}`)
        .then((response) => {
          setDirectors(response.data?.diretores || []);
          setCourseHistoryFeespOnlyApproval(response.data?.historico_cursos);
        })
        .catch((error) => {
          console.log('error', error);
        });
    } catch (err) {
      console.log(err);
    }
  }, [idSelected]);

  useEffect(() => {
    if (id || userId) {
      getCourseHistoryOnlyFeespApproved();
    }
  }, [id, userId, getCourseHistoryOnlyFeespApproved]);

  const loadImageBase64 = (path) => {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.onload = function () {
        const reader = new FileReader();
        reader.onloadend = function () {
          resolve(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.onerror = reject;
      xhr.open('GET', path);
      xhr.responseType = 'blob';
      xhr.send();
    });
  };

  const getDirectorForCourse = (course) => {
    const areaName = course?.Turma?.Curso?.Departamento?.Areas?.nome;
    if (!areaName) return null;

    const director = directors.find((d) => d.Area?.nome === areaName);

    //return director || directors.find(d => d.Area?.nome === 'ENSINO');
    // se nao houver diretor, entao retorna null
    return director || null;
  };

  const generatePDF = async (historico, pessoa, diretores) => {
    const coursesByArea = historico.reduce((acc, item) => {
      const areaName = item.Turma?.Curso?.Departamento?.Areas?.nome || 'OUTROS';
      if (!acc[areaName]) {
        acc[areaName] = [];
      }
      acc[areaName].push(item);
      return acc;
    }, {});

    const areas = Object.keys(coursesByArea);
    const content = [];

    const logoBase64 = await loadImageBase64('/images/logositefeesp.png');

    for (let i = 0; i < areas.length; i++) {
      const areaName = areas[i];
      const areaCourses = coursesByArea[areaName];

      const areaDirector = diretores.find(
        (d) => d.Area?.nome === areaName
      ); /* || diretores[0] */

      const areaObj = areaCourses[0]?.Turma?.Curso?.Departamento?.Areas;
      const imageName = areaObj?.imagem_area;
      const areaPhone = areaObj?.telefone || '';
      const areaRamal = areaObj?.ramal || '';

      let iconAreaBase64 = null;
      if (imageName) {
        try {
          iconAreaBase64 = await loadImageBase64(
            `${process.env.REACT_APP_API_KEY}/images/${imageName}`
          );
        } catch (e) {
          console.warn('Could not load area image', imageName);
        }
      }

      let assinaturaBase64 = null;
      if (areaDirector?.assinatura) {
        try {
          assinaturaBase64 = await loadImageBase64(
            `${process.env.REACT_APP_API_KEY}/images/${areaDirector?.assinatura}`
          );
        } catch (e) {
          console.warn('Could not load signature', areaDirector?.assinatura);
        }
      }

      const cursosTable = areaCourses.map((item) => [
        { text: item.ano_de_conclusao ?? '-', alignment: 'center' },
        item.Turma.Curso.nome,
        { text: item.Turma?.Curso?.carga_horaria ?? '-', alignment: 'center' },
      ]);

      const pageContent = [
        {
          columns: [
            {
              image: logoBase64,
              width: 200,
              alignment: 'left',
              margin: [0, 0, 0, 0],
            },
            { text: '', width: '*' },
            iconAreaBase64
              ? {
                  image: iconAreaBase64,
                  fit: [200, 23],
                  width: 200,
                  alignment: 'right',
                  margin: [0, 15, 0, 0],
                }
              : { text: '', width: 200 },
          ],
        },
        {
          text: '\nDECLARAÇÃO DE CURSOS REALIZADOS\n',
          style: 'header',
          alignment: 'center',
        },
        {
          text: [
            'Declaramos, para os devidos fins, que ',
            { text: pessoa.nome, bold: true, fontSize: 14 },
            `, CPF ${
              pessoa.cpf ?? '-'
            }, concluiu os seguintes cursos em nossa instituição relacionados à área de `,
            { text: areaName, bold: true },
            ':',
          ],
          style: 'body',
        },
        {
          table: {
            widths: ['auto', '*', 'auto'],
            body: [
              [
                { text: 'ANO DE CONCLUSÃO', style: 'tableHeader' },
                { text: 'CURSO', style: 'tableHeader' },
                { text: 'CARGA HORÁRIA', style: 'tableHeader' },
              ],
              ...cursosTable,
            ],
          },
          style: 'table',
        },
        {
          unbreakable: true,
          stack: [
            {
              text: '\nColocamo-nos à disposição para quaisquer esclarecimentos.',
              style: 'body',
            },
            {
              text: '\nAtenciosamente,\n',
              style: 'body',
            },
            {
              alignment: 'center',
              stack: [
                ...(assinaturaBase64
                  ? [
                      {
                        image: assinaturaBase64,
                        fit: [150, 80],
                      },
                      { text: '______________________________' },
                      {
                        text: `${areaDirector?.User?.nome || 'Diretoria'}`,
                        bold: true,
                      },
                      {
                        text: `Direção da Área de ${capitalizeFLetter(
                          areaName.toLowerCase()
                        )}`,
                      },
                    ]
                  : [
                      {
                        text: `Direção da Área de ${capitalizeFLetter(
                          areaName.toLowerCase()
                        )}`,
                      },
                    ]),

                {
                  text: `Emitido em ${new Date().toLocaleDateString(
                    'pt-BR'
                  )}, às ${new Date().toLocaleTimeString('pt-BR')}, via sistema.${
                    areaPhone
                      ? ` Dúvidas: entrar em contato com a área de ${capitalizeFLetter(
                          areaName.toLowerCase()
                        )} pelo telefone ${areaPhone}${
                          areaRamal ? ` ramal ${areaRamal}` : ''
                        }`
                      : ''
                  }`,
                  fontSize: 10,
                  marginTop: 40,
                },
              ],
            },
          ],
        },
      ];

      if (i < areas.length - 1) {
        pageContent[pageContent.length - 1].pageBreak = 'after';
      }

      content.push(...pageContent);
    }

    const docDefinition = {
      content: content,
      styles: {
        header: {
          fontSize: 14,
          bold: true,
          margin: [0, 10, 0, 10],
        },
        subheader: {
          fontSize: 12,
          margin: [0, 10, 0, 10],
        },
        body: {
          fontSize: 11,
          margin: [0, 10, 0, 10],
        },
        table: {
          margin: [0, 10, 0, 10],
        },
        tableHeader: {
          bold: true,
          fontSize: 10,
          color: 'black',
          fillColor: '#eeeeee',
        },
      },
    };

    pdfMake.createPdf(docDefinition).open();
  };

  const generateCertificate = (course) => {
    const director = getDirectorForCourse(course);
    
    if (!director) {
      return toast(
        'error',
        'Diretoria não cadastrada para este curso. Entrar em contado com a Secretaria de Ensino: 011 3188-8383 r. 237'
      );
    }
    const areaImageUrl = director?.Area?.imagem_area
    ? `${process.env.REACT_APP_API_KEY}/images/${director.Area.imagem_area}`
    : null;

    Promise.all([
      loadImageBase64('/images/certificado_moldura.png'),
      loadImageBase64('/images/logositefeesp.png'),
      loadImageBase64(
        `${process.env.REACT_APP_API_KEY}/images/${director?.assinatura}`
      ),
      //loadImageBase64('/images/ICONE_AREA_ENSINO.png'),
      areaImageUrl
      ? loadImageBase64(areaImageUrl).catch(() => null)
      : Promise.resolve(null),
    ])
      .then(([backgroundBase64, logoBase64, assinaturaBase64, iconArea]) => {
        const timestamp = course.ano_de_conclusao
          ? moment(course.ano_de_conclusao, 'YYYY')
          : moment();

        const cargaHoraria = course?.Turma?.Curso?.carga_horaria;
        const anoTurma = course?.ano_de_conclusao || course?.Turma?.ano;
        const nomeDoCurso = course?.Turma?.Curso?.nome;

        const areaObj = director?.Area;
        const areaName = areaObj?.nome || '';
        const areaPhone = areaObj?.telefone || '';
        const areaRamal = areaObj?.ramal || '';

        const texto = cargaHoraria
          ? `Com carga horária de: ${cargaHoraria}, em ${anoTurma}.`
          : 'Com carga horária de: -.';

        const docDefinition = {
          pageSize: 'A4',
          pageMargins: [60, 50, 60, 50],
          background: [
            {
              image: backgroundBase64,
              width: 590,
            },
          ],
          content: [
            {
              columns: [
                {
                  image: logoBase64,
                  width: 200,
                  alignment: 'left',
                  margin: [0, 0, 0, 10],
                },
                ...(iconArea
                  ? [
                      {
                        image: iconArea,
                        width: 135,
                        margin: [135, 30, 0, 0],
                      },
                    ]
                  : []),
              ],
            },
            {
              stack: [
                {
                  text: 'CERTIFICADO',
                  style: 'header',
                  alignment: 'center',
                },
                {
                  text: [
                    {
                      text: 'Conferido a ',
                      style: 'content',
                      alignment: 'center',
                    },
                    {
                      text: `${user.nome}, `,
                      style: 'content',
                      alignment: 'center',
                      bold: true,
                      font: 'GreatVibes',
                      fontSize: 28,
                    },
                    {
                      text: `CPF ${user.cpf ?? '-'},`,
                      style: 'content',
                      alignment: 'center',
                    },
                    {
                      text: ' pela conclusão do curso: ',
                      style: 'content',
                      alignment: 'center',
                    },
                    {
                      text: `${nomeDoCurso}. `,
                      style: 'content',
                      alignment: 'center',
                      bold: true,
                    },
                    {
                      text: `${texto}`,
                      style: 'content',
                      alignment: 'center',
                    },
                  ],
                  margin: [0, 5, 0, 5],
                },
                {
                  alignment: 'center',
                  stack: [
                    {
                      image: assinaturaBase64,
                      width: 150,
                      height: 60,
                      absolutePosition: { x: 50, y: 260 },
                    },
                    {
                      text: '______________________________',
                      absolutePosition: { x: 50, y: 300 },
                    },
                    {
                      text: `${director?.User?.nome}`,
                      bold: true,
                      absolutePosition: { x: 50, y: 315 },
                    },
                    {
                      text: `Direção da Área de ${capitalizeFLetter(
                        director?.Area?.nome?.toLowerCase() || 'ensino'
                      )}`,
                      absolutePosition: { x: 50, y: 330 },
                    },
                    /* {
                      text: (director?.User?.celular || '').length >= (director?.User?.telefone || '').length
                        ? (director?.User?.celular || '')
                        : (director?.User?.telefone || ''),
                      fontSize: 10,
                      absolutePosition: { x: 50, y: 345 },
                    }, */
                  ],
                },
                {
                  text: `São Paulo. Emitido em ${new Date().toLocaleDateString(
                    'pt-BR'
                  )}, às ${new Date().toLocaleTimeString(
                    'pt-BR'
                  )}, via sistema.${
                    areaPhone
                      ? ` Dúvidas: entrar em contato com a área de ${capitalizeFLetter(
                          areaName.toLowerCase()
                        )} pelo telefone ${areaPhone}${
                          areaRamal ? ` ramal ${areaRamal}` : ''
                        }`
                      : ''
                  }`,
                  style: 'dataEmissao',
                  alignment: 'center',
                  absolutePosition: { x: 50, y: 365 },
                },
              ],
            },
          ],
          defaultStyle: {
            font: 'Roboto',
          },
          styles: {
            header: {
              fontSize: 24,
              bold: true,
              margin: [0, 10, 0, 0],
              color: '#1473B9',
            },
            content: {
              fontSize: 18,
              margin: [0, 10, 0, 10],
            },
            dataEmissao: {
              fontSize: 10,
              italics: true,
              margin: [0, 40, 0, 0],
            },
          },
        };

        pdfMake.createPdf(docDefinition).open();
      })
      .catch((error) => {
        console.error('Erro ao carregar as imagens:', error);
        alert('Erro ao gerar certificado. Verifique conexao e assinaturas.');
      });
  };

  return (
    <JumboContentLayout layoutOptions={layoutOptions}>
      {lg && (
        <Stack spacing={2} direction={'row'} sx={{ mb: 3, mt: -2 }}></Stack>
      )}
      <Paper sx={{ p: '40px', height: '500px' }}>
        <Box sx={{ height: '100%', overflowY: 'auto' }}>
          <Box
            display='flex'
            justifyContent='flex-end'
            alignItems='center'
            marginRight='1rem'
            gap={1}
          >
            <Button size='small' variant='contained' onClick={handleClose}>
              Fechar
            </Button>
          </Box>
          <Box
            display='flex'
            justifyContent='flex-end'
            alignItems='center'
            marginRight='1rem'
            marginTop='1rem'
          >
            <Button
              size='small'
              variant='contained'
              color='success'
              disabled={
                courseHistoryFeespOnlyApproval.length === 0 ||
                directors.length === 0
              }
              onClick={() =>
                generatePDF(courseHistoryFeespOnlyApproval, user, directors)
              }
            >
              Declarações de Cursos (PDF)
            </Button>
          </Box>
          <Typography
            variant={'h1'}
            style={{ textAlign: 'center', marginBottom: 30 }}
          >
            {modalTitle}
          </Typography>
          <Box display={'flex'} gap={1} alignItems={'center'}>
            <Typography variant='h4' fontWeight={'300'}>
              Aluno selecionado:
            </Typography>
            <Typography
              variant='h4'
              textTransform={'capitalize'}
              fontWeight={'600'}
            >
              {username}
            </Typography>
          </Box>

          <CourseWithCertifiedList
            coursesCertified={courseHistoryFeespOnlyApproval}
            onPrint={(course) => generateCertificate(course)}
          />
        </Box>
      </Paper>
    </JumboContentLayout>
  );
};

export default ModalCertified;
